import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface BulkShiftUploadFailureProps extends BaseTemplateProps {
  csvHistoryLink: string
}

export const BulkShiftUploadFailure: TemplateDefinition<BulkShiftUploadFailureProps> = {
  renderParams: (props: BulkShiftUploadFailureProps) => ({
    messageKey: 'notificationsDomain.templates.bulkShiftUploadFailureSubheader',
    values: {
      givenName: props.givenName,
      csvHistoryLink: props.csvHistoryLink,
    },
  }),
  getLink: (props: BulkShiftUploadFailureProps): string => props?.csvHistoryLink || '',
}
